import DepsService from 'services/dependencies';

const LABELS = {
  MANAGE_USERS: () => DepsService.gettextCatalog.getString('Manage Users'),
  SITE_ACTIVITY_LOG: () => DepsService.gettextCatalog.getString('Site Activity Log'),
  REPORTS: () => DepsService.gettextCatalog.getString('Reports'),
  RETAILER_DASHBOARDS: () => DepsService.gettextCatalog.getString('Retailer Dashboards'),
  MANAGE_CONTENT: () => DepsService.gettextCatalog.getString('Manage Content'),
  MANAGE_ROLES: () => DepsService.gettextCatalog.getString('Manage Roles'),
  HOME_PAGE_BANNERS: () => DepsService.gettextCatalog.getString('Home Page Banners'),
  HOME_PAGE_WIDGETS: () => DepsService.gettextCatalog.getString('Home Page Widgets'),
  LEGAL_POLICIES: () => DepsService.gettextCatalog.getString('Legal Policies'),
  LOGIN_NOTIFICATION: () => DepsService.gettextCatalog.getString('Login Notification'),
  LOTTERY_CONTACTS: () => DepsService.gettextCatalog.getString('Lottery Contacts'),
  INQUIRY_CONTACTS: () => DepsService.gettextCatalog.getString('Inquiry Contacts'),
  DOCUMENTS_LIBRARY: () => DepsService.gettextCatalog.getString('Documents Library'),
  NOTIFICATION_TEMPLATES: () => DepsService.gettextCatalog.getString('Notification Templates'),
  MANAGE_FAQ: () => DepsService.gettextCatalog.getString('Manage FAQs'),
  MANAGE_CONFIGURABLE_LINK: () => DepsService.gettextCatalog.getString('Manage Configurable Link'),
  RETAILER_ROLES_SECONDARY: () => DepsService.gettextCatalog.getString('Secondary Retailer Roles'),
  RETAILER_ROLES_PRIMARY: () => DepsService.gettextCatalog.getString('Primary Retailer Roles'),
  ADMIN_ROLES: () => DepsService.gettextCatalog.getString('Admin Roles'),
  SFTP_CONFIGURATION: () => DepsService.gettextCatalog.getString('SFTP Configuration'),
  REPORT_FORMATS: () => DepsService.gettextCatalog.getString('Report Formats'),
  LOTTERY_ANNOUNCEMENTS: () => DepsService.gettextCatalog.getString('Lottery Announcements'),
  SUMMARY_DASHBOARD: () => DepsService.gettextCatalog.getString('Summary Dashboard'),
  INSTANTS_DASHBOARD: () => {
    const { dictionary, session } = DepsService.$ngRedux.getState();
    const { locale } = session;
    const terms = dictionary.terms[locale];

    /// {{ instant }} is Lottery term using to determine Instant games.
    return DepsService.gettextCatalog.getString('{{ instant }} Dashboard', { instant: terms.INSTANT.plural });
  },
  STORE_PROFILES: () => DepsService.gettextCatalog.getString('Store Profiles'),
  TRAINING: () => DepsService.gettextCatalog.getString('Training'),
  BRAND_GUIDE: () => DepsService.gettextCatalog.getString('Brand Guide'),
  COLOR_PALETTE: () => DepsService.gettextCatalog.getString('Color Palette'),
  GAME_IMAGES: () => DepsService.gettextCatalog.getString('Game Images'),
  MEDIA_TEMPLATES: () => DepsService.gettextCatalog.getString('Media Templates'),
};

export default {
  roles: {
    ADMIN: {
      retailerType: 'ADMIN',
      sidemenu: {
        0: {
          label: LABELS.MANAGE_USERS,
          icon: 'fa-users',
          sref: 'user-manageUsers',
        },
        1: {
          label: LABELS.SITE_ACTIVITY_LOG,
          icon: 'fa-book',
          sref: 'retailerReports-admin',
        },
        2: {
          label: LABELS.REPORTS,
          icon: 'fa-bar-chart',
          sref: 'retailerReports-view',
        },
        3: {
          label: LABELS.RETAILER_DASHBOARDS,
          icon: 'fa-tachometer',
          sref: 'retailerWidgets-view',
        },
        4: {
          id: 'cms',
          label: LABELS.MANAGE_CONTENT,
          icon: 'fa-folder-open',
        },
        '4.0': {
          id: 'cms.bannersManagement',
          label: LABELS.HOME_PAGE_BANNERS,
          icon: 'fa-folder',
          sref: 'cms-bannersManagement',
        },
        4.1: {
          id: 'cms.widgetsManagement',
          label: LABELS.HOME_PAGE_WIDGETS,
          icon: 'fa-folder',
          sref: 'cms-widgetsManagement',
        },
        4.2: {
          id: 'cms.termsOfUseManagement',
          label: LABELS.LEGAL_POLICIES,
          icon: 'fa-folder',
          sref: 'cms-termsOfUseManagement',
        },
        4.3: {
          id: 'cms.loginPopupManagement',
          label: LABELS.LOGIN_NOTIFICATION,
          icon: 'fa-folder',
          sref: 'cms-loginPopupManagement',
        },
        4.4: {
          id: 'cms.reportFormatsManagement',
          label: LABELS.REPORT_FORMATS,
          icon: 'fa-folder',
          sref: 'retailerReports-manageFormats',
        },
        4.5: {
          id: 'cms.contactManagement',
          label: LABELS.LOTTERY_CONTACTS,
          icon: 'fa-folder',
          sref: 'contact-manage',
        },
        4.6: {
          id: 'cms.inquiryReasonManagement',
          label: LABELS.INQUIRY_CONTACTS,
          icon: 'fa-folder',
          sref: 'cms-inquiryReasonManagement',
        },
        4.7: {
          label: LABELS.DOCUMENTS_LIBRARY,
          sref: 'documents-view',
          icon: 'fa-file',
          id: 'cms.documents',
        },
        4.8: {
          label: LABELS.NOTIFICATION_TEMPLATES,
          icon: 'fa-bell',
          sref: 'emailNotificationsTemplates-view',
          id: 'cms.emailNotificationsTemplates',
        },
        4.9: {
          label: LABELS.MANAGE_FAQ,
          icon: 'fa-folder-open',
          sref: 'faq-admin',
          id: 'cms.faq',
        },
        '4.10': {
          id: 'cms.announcementsManagement',
          label: LABELS.LOTTERY_ANNOUNCEMENTS,
          icon: 'fa-folder',
          sref: 'cms-newsManagement',
        },
        4.11: {
          id: 'cms.manageConfigurableLink',
          label: LABELS.MANAGE_CONFIGURABLE_LINK,
          icon: 'fa-folder',
          sref: 'cms-manageConfigurableLink',
        },
        4.12: {
          id: 'cms.manageTheme',
          label: LABELS.COLOR_PALETTE,
          icon: 'fa-folder',
          sref: 'cms-manageTheme',
        },
        4.13: {
          id: 'cms.gameImages',
          label: LABELS.GAME_IMAGES,
          icon: 'fa-folder',
          sref: 'cms-gameImages',
        },
        4.14: {
          id: 'cms.mediaTemplates',
          label: LABELS.MEDIA_TEMPLATES,
          sref: 'cms-mediaTemplates',
        },
        5: {
          id: 'privileges',
          label: LABELS.MANAGE_ROLES,
          icon: 'fa-key',
        },
        '5.0': {
          id: 'privileges.retailerPrimary',
          label: LABELS.RETAILER_ROLES_PRIMARY,
          sref: 'privilegeTemplates-retailerViewPrimary',
        },
        5.1: {
          id: 'privileges.retailerSecondary',
          label: LABELS.RETAILER_ROLES_SECONDARY,
          sref: 'privilegeTemplates-retailerViewSecondary',
        },
        5.2: {
          id: 'privileges.lottery',
          label: LABELS.ADMIN_ROLES,
          sref: 'privilegeTemplates-lotteryView',
        },
        6: {
          label: LABELS.SFTP_CONFIGURATION,
          icon: 'fa-hdd-o',
          sref: 'sftp-view',
        },
      },
    },
    RETAILER_PRIMARY_INDEPENDENT: {
      sidemenu: {
        1: {
          label: LABELS.SUMMARY_DASHBOARD,
          icon: 'fa-tachometer',
          sref: 'dashboard-summary',
        },
        2: {
          label: LABELS.INSTANTS_DASHBOARD,
          icon: 'fa-calculator',
          sref: 'dashboard-instant',
        },
        3: {
          label: LABELS.REPORTS,
          icon: 'fa-bar-chart',
          sref: 'retailerReports-view',
        },
        4: {
          label: LABELS.DOCUMENTS_LIBRARY,
          sref: 'documents-view',
          icon: 'fa-file',
        },
        5: {
          label: LABELS.MANAGE_USERS,
          icon: 'fa-users',
          sref: 'user-manageUsers',
        },
        6: {
          id: 'training',
          label: LABELS.TRAINING,
          icon: 'fa-graduation-cap',
          plainLink: true,
          target: '_blank',
        },
        7: {
          id: 'branding',
          label: LABELS.BRAND_GUIDE,
          icon: 'fa-bullseye',
          plainLink: true,
          target: '_blank',
        },
      },
    },
    RETAILER_PRIMARY_CHAIN_HEAD: {
      sidemenu: {
        1: {
          label: LABELS.SUMMARY_DASHBOARD,
          icon: 'fa-tachometer',
          sref: 'dashboard-summary',
        },
        2: {
          label: LABELS.INSTANTS_DASHBOARD,
          icon: 'fa-calculator',
          sref: 'dashboard-instant',
        },
        3: {
          label: LABELS.STORE_PROFILES,
          icon: 'fa-bank',
          sref: 'storeProfiles-view',
        },
        4: {
          label: LABELS.REPORTS,
          icon: 'fa-bar-chart',
          sref: 'retailerReports-view',
        },
        5: {
          label: LABELS.DOCUMENTS_LIBRARY,
          sref: 'documents-view',
          icon: 'fa-file',
        },
        6: {
          label: LABELS.MANAGE_USERS,
          icon: 'fa-users',
          sref: 'user-manageUsers',
        },
        7: {
          id: 'training',
          label: LABELS.TRAINING,
          icon: 'fa-graduation-cap',
          plainLink: true,
          target: '_blank',
        },
        8: {
          id: 'branding',
          label: LABELS.BRAND_GUIDE,
          icon: 'fa-bullseye',
          plainLink: true,
          target: '_blank',
        },
      },
    },
    RETAILER_PRIMARY_CHAIN_SUBORDINATE: {
      sidemenu: {
        1: {
          label: LABELS.SUMMARY_DASHBOARD,
          icon: 'fa-tachometer',
          sref: 'dashboard-summary',
        },
        2: {
          label: LABELS.INSTANTS_DASHBOARD,
          icon: 'fa-calculator',
          sref: 'dashboard-instant',
        },
        3: {
          label: LABELS.REPORTS,
          icon: 'fa-bar-chart',
          sref: 'retailerReports-view',
        },
        4: {
          label: LABELS.DOCUMENTS_LIBRARY,
          sref: 'documents-view',
          icon: 'fa-file',
        },
        5: {
          label: LABELS.MANAGE_USERS,
          icon: 'fa-users',
          sref: 'user-manageUsers',
        },
        6: {
          id: 'training',
          label: LABELS.TRAINING,
          icon: 'fa-graduation-cap',
          plainLink: true,
          target: '_blank',
        },
        7: {
          id: 'branding',
          label: LABELS.BRAND_GUIDE,
          icon: 'fa-bullseye',
          plainLink: true,
          target: '_blank',
        },
      },
    },
    RETAILER_SECONDARY_INDEPENDENT: {
      sidemenu: {
        1: {
          label: LABELS.SUMMARY_DASHBOARD,
          icon: 'fa-tachometer',
          sref: 'dashboard-summary',
        },
        2: {
          label: LABELS.INSTANTS_DASHBOARD,
          icon: 'fa-calculator',
          sref: 'dashboard-instant',
        },
        3: {
          label: LABELS.REPORTS,
          icon: 'fa-bar-chart',
          sref: 'retailerReports-view',
        },
        4: {
          label: LABELS.DOCUMENTS_LIBRARY,
          sref: 'documents-view',
          icon: 'fa-file',
        },
        5: {
          id: 'training',
          label: LABELS.TRAINING,
          icon: 'fa-graduation-cap',
          plainLink: true,
          target: '_blank',
        },
        6: {
          id: 'branding',
          label: LABELS.BRAND_GUIDE,
          icon: 'fa-bullseye',
          plainLink: true,
          target: '_blank',
        },
        7: {
          label: LABELS.MANAGE_USERS,
          icon: 'fa-users',
          sref: 'user-manageUsers',
        },
      },
    },
    RETAILER_SECONDARY_CHAIN_HEAD: {
      sidemenu: {
        1: {
          label: LABELS.SUMMARY_DASHBOARD,
          icon: 'fa-tachometer',
          sref: 'dashboard-summary',
        },
        2: {
          label: LABELS.INSTANTS_DASHBOARD,
          icon: 'fa-calculator',
          sref: 'dashboard-instant',
        },
        3: {
          label: LABELS.STORE_PROFILES,
          icon: 'fa-bank',
          sref: 'storeProfiles-view',
        },
        4: {
          label: LABELS.REPORTS,
          icon: 'fa-bar-chart',
          sref: 'retailerReports-view',
        },
        5: {
          label: LABELS.DOCUMENTS_LIBRARY,
          sref: 'documents-view',
          icon: 'fa-file',
        },
        6: {
          id: 'training',
          label: LABELS.TRAINING,
          icon: 'fa-graduation-cap',
          plainLink: true,
          target: '_blank',
        },
        7: {
          id: 'branding',
          label: LABELS.BRAND_GUIDE,
          icon: 'fa-bullseye',
          plainLink: true,
          target: '_blank',
        },
        8: {
          label: LABELS.MANAGE_USERS,
          icon: 'fa-users',
          sref: 'user-manageUsers',
        },
      },
    },
    RETAILER_SECONDARY_CHAIN_SUBORDINATE: {
      sidemenu: {
        1: {
          label: LABELS.SUMMARY_DASHBOARD,
          icon: 'fa-tachometer',
          sref: 'dashboard-summary',
        },
        2: {
          label: LABELS.INSTANTS_DASHBOARD,
          icon: 'fa-calculator',
          sref: 'dashboard-instant',
        },
        3: {
          label: LABELS.REPORTS,
          icon: 'fa-bar-chart',
          sref: 'retailerReports-view',
        },
        4: {
          label: LABELS.DOCUMENTS_LIBRARY,
          sref: 'documents-view',
          icon: 'fa-file',
        },
        5: {
          id: 'training',
          label: LABELS.TRAINING,
          icon: 'fa-graduation-cap',
          plainLink: true,
          target: '_blank',
        },
        6: {
          id: 'branding',
          label: LABELS.BRAND_GUIDE,
          icon: 'fa-bullseye',
          plainLink: true,
          target: '_blank',
        },
        7: {
          label: LABELS.MANAGE_USERS,
          icon: 'fa-users',
          sref: 'user-manageUsers',
        },
      },
    },
    RETAILER_GROUP: {
      sidemenu: {
        3: {
          label: LABELS.REPORTS,
          icon: 'fa-bar-chart',
          sref: 'retailerReports-view',
        },
        4: {
          label: LABELS.DOCUMENTS_LIBRARY,
          sref: 'documents-view',
          icon: 'fa-file',
        },
        5: {
          id: 'training',
          label: LABELS.TRAINING,
          icon: 'fa-graduation-cap',
          plainLink: true,
          target: '_blank',
        },
      },
    },
    RETAILER_PRIMARY_SUPER_CHAIN: {
      sidemenu: {
        1: {
          label: LABELS.SUMMARY_DASHBOARD,
          icon: 'fa-tachometer',
          sref: 'dashboard-summary',
        },
        2: {
          label: LABELS.INSTANTS_DASHBOARD,
          icon: 'fa-calculator',
          sref: 'dashboard-instant',
        },
        3: {
          label: LABELS.REPORTS,
          icon: 'fa-bar-chart',
          sref: 'retailerReports-view',
        },
        4: {
          label: LABELS.DOCUMENTS_LIBRARY,
          sref: 'documents-view',
          icon: 'fa-file',
        },
        5: {
          label: LABELS.MANAGE_USERS,
          icon: 'fa-users',
          sref: 'user-manageUsers',
        },
        6: {
          id: 'training',
          label: LABELS.TRAINING,
          icon: 'fa-graduation-cap',
          plainLink: true,
          target: '_blank',
        },
      },
    },
    RETAILER_SECONDARY_SUPER_CHAIN: {
      sidemenu: {
        1: {
          label: LABELS.SUMMARY_DASHBOARD,
          icon: 'fa-tachometer',
          sref: 'dashboard-summary',
        },
        2: {
          label: LABELS.INSTANTS_DASHBOARD,
          icon: 'fa-calculator',
          sref: 'dashboard-instant',
        },
        3: {
          label: LABELS.REPORTS,
          icon: 'fa-bar-chart',
          sref: 'retailerReports-view',
        },
        4: {
          label: LABELS.DOCUMENTS_LIBRARY,
          sref: 'documents-view',
          icon: 'fa-file',
        },
        5: {
          label: LABELS.MANAGE_USERS,
          icon: 'fa-users',
          sref: 'user-manageUsers',
        },
        6: {
          id: 'training',
          label: LABELS.TRAINING,
          icon: 'fa-graduation-cap',
          plainLink: true,
          target: '_blank',
        },
      },
    },
    RETAILER_PRIMARY_CHAIN_HEAD_SUPER_CHAIN: {
      sidemenu: {
        1: {
          label: LABELS.SUMMARY_DASHBOARD,
          icon: 'fa-tachometer',
          sref: 'dashboard-summary',
        },
        2: {
          label: LABELS.INSTANTS_DASHBOARD,
          icon: 'fa-calculator',
          sref: 'dashboard-instant',
        },
        3: {
          label: LABELS.REPORTS,
          icon: 'fa-bar-chart',
          sref: 'retailerReports-view',
        },
        4: {
          label: LABELS.DOCUMENTS_LIBRARY,
          sref: 'documents-view',
          icon: 'fa-file',
        },
        6: {
          id: 'training',
          label: LABELS.TRAINING,
          icon: 'fa-graduation-cap',
          plainLink: true,
          target: '_blank',
        },
        7: {
          label: LABELS.STORE_PROFILES,
          icon: 'fa-bank',
          sref: 'storeProfiles-view',
        },
        8: {
          label: LABELS.MANAGE_USERS,
          icon: 'fa-users',
          sref: 'user-manageUsers',
        },
      },
    },
    RETAILER_SECONDARY_CHAIN_HEAD_SUPER_CHAIN: {
      sidemenu: {
        1: {
          label: LABELS.SUMMARY_DASHBOARD,
          icon: 'fa-tachometer',
          sref: 'dashboard-summary',
        },
        2: {
          label: LABELS.INSTANTS_DASHBOARD,
          icon: 'fa-calculator',
          sref: 'dashboard-instant',
        },
        3: {
          label: LABELS.REPORTS,
          icon: 'fa-bar-chart',
          sref: 'retailerReports-view',
        },
        4: {
          label: LABELS.DOCUMENTS_LIBRARY,
          sref: 'documents-view',
          icon: 'fa-file',
        },
        5: {
          label: LABELS.STORE_PROFILES,
          icon: 'fa-bank',
          sref: 'storeProfiles-view',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/modules/app/config/sidemenu.js